import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AdminComponent } from './admin/admin.component';
import { ReportsComponent } from './reports/reports.component';
import { EmailerComponent } from './emailer/emailer.component';
import { MsalGuard } from './msal';
import { GuardService } from './guard-service';

const routes: Routes = [
    {path: '', redirectTo: '/home', pathMatch: 'full'},
    {path:'home',component: HomeComponent,canActivate: [MsalGuard]},
    {path:'admin',component: AdminComponent,canActivate: [MsalGuard]},
    {path:'reports',component: ReportsComponent,canActivate: [MsalGuard]},
    {path:'emailer',component: EmailerComponent,canActivate: [MsalGuard]},
    {path: '**', redirectTo: '/home', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [GuardService]
})
export class AppRoutingModule { }